import clsx from "clsx";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  /** Names the switch when its visible label lives elsewhere (e.g. a row). */
  ariaLabel?: string;
  disabled?: boolean;
}

export function Switch({
  checked,
  onChange,
  label,
  ariaLabel,
  disabled,
}: SwitchProps) {
  return (
    <label
      className={clsx(
        // `relative` is load-bearing: the input below is `sr-only`, which is
        // `position: absolute`. With no positioned ancestor its containing
        // block is the page itself, so a switch sitting low in a tall,
        // scrolling panel (Show Deleted, at the foot of the filters) escaped
        // the scroll container and stretched the document past the viewport —
        // which is the blank strip that appeared under the footer once a
        // filter was opened.
        "relative inline-flex items-center gap-2",
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
      )}
    >
      <input
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        className="sr-only peer"
      />
      <div className="w-9 h-5 bg-[rgb(var(--border))] peer-focus:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-[rgb(var(--text-accent))] peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-[rgb(var(--card))] rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-[rgb(var(--border))] after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-[rgb(var(--accent-fill))] relative" />
      {label && (
        <span className="text-xs font-medium text-[rgb(var(--text-secondary))]">
          {label}
        </span>
      )}
    </label>
  );
}
